<template>
  <v-container fluid>
    <v-card>
      <v-toolbar style="background:#F5F5F5" dense>
        <v-toolbar-title style="color:#01579B;font-weight:bold" dense>Historique des Commandes</v-toolbar-title>
      </v-toolbar>

      <v-col sm="12" class="text-center">
        <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            top
            color="#01579B"
        ></v-progress-linear>
      </v-col>
      <v-data-table
          :headers="headers"
          :items="cmdhisto"
          :search="search"
          :items-per-page="15"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          show-expand
          no-results-text="Aucun résultat"
          no-data-text="Aucun résultat"
          :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus'
            }"
      >
        <template v-slot:[`top`]>
          <v-toolbar flat color="white" :elevation="0" class="mt-4 mb-4">
            <v-btn large>
              <download-csv :data="cmdhisto" name="cmdhisto.csv">
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                Télécharger CSV
              </download-csv>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field :id="dynamicID()"
                          v-model="search"
                          append-icon="search"
                          label="Rechercher..."
                          single-line
                          hide-details
            >
            </v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:[`expanded-item`]="{ headers, item }">
          <td :colspan="headers.length">
            <vue-json-pretty :data="item"></vue-json-pretty>
          </td>
        </template>
        <template v-slot:[`item.createdDate`]="{ item }">
          {{ item.createdDate | formatDate }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import apiClient from "../../config/api.js";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  data() {
    return {
      isMobile: isMobileDevice(),
      search: "",
      loading: true,
      cmdhisto: [],
      headers: [
        {text: "Numéro de série", sortable: false, value: "serialNumber"},
        {text: "Commande", value: "command", sortable: false},
        {text: "Emetteur", value: "senderId", sortable: false},
        {text: "Date de création", value: "createDate", sortable: false},
        {text: "Statut", value: "state", sortable: false},
      ],
      expanded: [],
      singleExpand: true,
    };
  },
  created() {
    apiClient
        .post(
            `${this.$store.getters.user.baseUrl}/command/postpone/histo/926647279B9090C0/lamine`
        )
        .then((response) => {
          setTimeout(() => (this.loading = false), 3000);
          this.cmdhisto = response.data.datas;
        })
        .catch(() => {
          this.loading = false;
        });
  },
  methods: {
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
  }
};
</script>
